import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PackContents } from './components/PackContents';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { LaunchOffer } from './components/LaunchOffer';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { EmotionalClose } from './components/EmotionalClose';
import { Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
type AppProps = {
  showUrgencyBanner?: boolean;
  showSocialProofToast?: boolean;
};
export function App({
  showUrgencyBanner = true,
  showSocialProofToast = true
}: AppProps) {
  return <div className="min-h-screen w-full bg-brand-rice font-sans text-brand-ink selection:bg-brand-jadeMist selection:text-brand-jadeDeep" data-id="element-0" data-mp="28t4kmbsl46ry">
      {showUrgencyBanner && <UrgencyBanner data-id="element-1" data-mp="3ik7e6ay3c1o0" />}
      <main data-id="element-2" data-mp="3iiweam7rne26">
        <Hero data-id="element-3" data-mp="3ij65gd4jrr9g" />
        <PackContents data-id="element-4" data-mp="3ijpd910hgz9r" />
        <InitialTestimonials data-id="element-5" data-mp="3ii4ppvcl6gle" />
        <PainPoints data-id="element-6" data-mp="3mkrdnl64zhdb" />
        <LaunchOffer data-id="element-7" data-mp="3mk852v2dm5by" />
        <MoreTestimonials data-id="element-8" data-mp="3mjpyb4i388ps" />
        <FAQ data-id="element-9" data-mp="3rc9co3oln7vn" />
        <CostComparison data-id="element-10" data-mp="3rbrakqf99zft" />
        <EmotionalClose data-id="element-11" data-mp="3rdki07xp0nov" />
      </main>
      <Footer data-id="element-12" data-mp="3recc1ebn6dd1" />
      {showSocialProofToast && <FloatingNotification data-id="element-13" data-mp="67znpl2q47d" />}
    </div>;
}